import { Canvas as FabricCanvas, Rect, Ellipse, FabricObject } from 'fabric';

export interface DrawState {
  isDrawing: boolean;
  tool: string;
  shapeType?: string;
  startX: number;
  startY: number;
  currentX: number;
  currentY: number;
}

let drawingPreviewObj: FabricObject | null = null;

export function updateDrawingPreview(canvas: FabricCanvas, ds: DrawState, artboardLeft: number, artboardTop: number) {
  if (drawingPreviewObj) {
    canvas.remove(drawingPreviewObj);
    drawingPreviewObj = null;
  }

  const x = Math.min(ds.startX, ds.currentX);
  const y = Math.min(ds.startY, ds.currentY);
  const w = Math.abs(ds.currentX - ds.startX);
  const h = Math.abs(ds.currentY - ds.startY);

  if (w < 2 && h < 2) return;

  let preview: FabricObject | null = null;

  const isEllipse = ds.shapeType === 'circle';

  if (isEllipse) {
    preview = new Ellipse({
      left: artboardLeft + x,
      top: artboardTop + y,
      rx: w / 2,
      ry: h / 2,
      fill: 'rgba(6, 182, 212, 0.1)',
      stroke: '#06b6d4',
      strokeWidth: 1,
      strokeDashArray: [5, 5],
      selectable: false,
      evented: false,
    });
  } else {
    preview = new Rect({
      left: artboardLeft + x,
      top: artboardTop + y,
      width: w,
      height: h,
      fill: 'rgba(6, 182, 212, 0.1)',
      stroke: '#06b6d4',
      strokeWidth: 1,
      strokeDashArray: [5, 5],
      selectable: false,
      evented: false,
    });
  }

  if (preview) {
    (preview as any)._csIsPreview = true;
    canvas.add(preview);
    canvas.requestRenderAll();
    drawingPreviewObj = preview;
  }
}

export function clearDrawingPreview(canvas: FabricCanvas | null) {
  if (!canvas || !drawingPreviewObj) return;
  canvas.remove(drawingPreviewObj);
  drawingPreviewObj = null;
  canvas.requestRenderAll();
}
